import * as React from 'react'

import "./style.scss"

import {AppContext} from "../../../Context/AppContext"

import {postier} from "./Postier"

import {Download} from "../../Utils/Download"
import { Create } from './create'
import { useContext, useEffect, useState } from 'react'

export function Mesures() {

    const {token,site,client,setLoading,setType, type, setErrors, role} = useContext(AppContext)
    const [mesures, setMesureData] = useState([])
    const [filtreMesure, setFiltreMesure] = useState([])
    const [pagina, setPagina] = useState('main');
    const [filtre, setFiltre] = useState({id:"",name:"",type:""})
    const [change, setChange] = useState(false)
    console.log({site, client})
    
    const setMesures = (arg)=>{
        setLoading(false)
        setMesureData(arg)
    }

    const handleFilter = (e,field)=>{
        let filtreCopy = filtre
        const value  = e.target.value

        filtreCopy[field]=value

        setFiltre(filtreCopy)
        setChange(!change)

    }

    useEffect(() => {
        if (mesures[0]) {
            let mesuresCopy = [...mesures]

            let result = mesuresCopy.filter(m=>m.entity_analyzed_name&&m.entity_analyzed_name.includes(filtre.name))

            result = result.filter(m=>m.id_entity_analyzed&&m.id_entity_analyzed.includes(filtre.id))

            result = filtre.type !== "" ? result.filter(m=>m.Type&&m.Type.includes(filtre.type)) : result

            setFiltreMesure(result)
        } else {
            setFiltreMesure([])
        }
    }, [mesures, filtre, change])

    useEffect(() => {
        setLoading(true)
        site && postier.getMesures(token, client, site, setMesures, setErrors)
        site && postier.getTypes(token, setType, setErrors)
    }, [site, client])

    const camera = filtreMesure[0]?filtreMesure.map(cam=><Camera key={cam.id_entity_analyzed} cam={cam} />):null

    return (

        <div className="mesures">
            <h1>Gestion mesures</h1>
            {pagina !== "createMesure" && <div className="linear">
                <span style={{fontWeight: 'bold', fontSize: '1.1em'}}>Rechercher une mesure</span>
                <label>ID : </label>
                <input type="text" onChange={e=>handleFilter(e,"id")} />
                <label>Name : </label>
                <input type="text" onChange={e=>handleFilter(e,"name")} />
                <label>Type : </label>
                <select onChange={(e) => handleFilter(e, "type")}>
                    <option value="">Veuillez choisir un type</option>
                    {type.map((t) => {
                        return <option value={t.Label}>{t.Label}</option>
                    })}
                </select>
                {/* <input type="text" onChange={e=>handleFilter(e,"type")} /> */}
            </div>}
            {pagina === 'main' ? role !== 'Viewer' && <button onClick={() => setPagina('createMesure')}>Créér mesure</button> : <button onClick={() => setPagina('main')}>Retour au menu</button>}
            {pagina === 'createMesure' && <Create setPagina={setPagina} mesures={mesures}  setMesures={setMesures} />}
            {pagina === 'main' && 
            <table id="table">
                        <thead>
                            <tr className="line" >
                                <td>ID</td>
                                <td>Name</td>
                                <td>Type</td>
                                <td>Description</td>
                                {role !== 'Viewer' && <td>Modifier</td>}

                            </tr>
                        </thead>
                        <tbody>
                            {camera}
                        </tbody>
                    </table>
            }
                    {pagina !== "createMesure" && <Download id="table" clientCode={client.split(":")[0]} siteId={site.split(":")[0]} type={"measures"} />}
                    
        </div>

        
    )
}

function Camera({cam}) {
    const { token, client, type, setErrors, role } = useContext(AppContext)

    const [modify, setModify] = useState<boolean>(false)
    const [name, setName] = useState<string>(cam.entity_analyzed_name)
    const [typeName, setTypeName] = useState<string>(cam.Type)
    const [description, setDescription] = useState<string>(cam.description)

    const button = () => {
        setModify(!modify)

        if (modify) {
            let typeID

            type.forEach(element => {
                if(element.Label==typeName){
                    typeID=element.ID
                }
            });

            const camera = {
                code: cam.client,
                database: client.split(":")[3],
                id_site: cam.id_site,
                entity_name:name,
                entity_type:typeID,
                is_monitored:JSON.stringify(cam.is_active),
                id_entity:cam.id_entity_analyzed,
                description
            }

            cam.entity_analyzed_name=name
            cam.Type = typeName
            cam.description = description
    
            postier.updateMesures(token,camera,client, setErrors)
        }
    }

    const input = <>
        <td>{cam.id_entity_analyzed}</td>
        <td><input type="text" defaultValue={cam.entity_analyzed_name} onChange={e=>{setName(e.target.value)}}  /></td>
        <td>
            <select defaultValue={cam.Type} onChange={e=>{setTypeName(e.target.value)}}>
                {type[0]&&type.map(t=>
                <option key={t.ID} value={t.label}>
                    {t.Label}
                </option>)}
            </select>
        </td>
        <td><input type="text" style={{border: "1px solid black", padding: '1em'}} defaultValue={cam.description} onChange={e=>{setDescription(e.target.value.replace(/'/g, "''"))}}  /></td>
    </>

    const render = <>
        <td>{cam.id_entity_analyzed}</td>
        <td>{cam.entity_analyzed_name}</td>
        <td>{cam.Type}</td>
        <td>{cam.description}</td>
    </>

    return <tr className="line" >
    {modify ? input : render}
    <td>{role !== 'Viewer' && <button onClick={button} >{modify?"Valider":"Modifier"}</button>}{modify && <button style={{margin: '1em'}} onClick={() => setModify(!modify)}>Annuler</button>}</td>
</tr>
}